import artworks from '../../data/artworks';
import ArtworkCard from '../../components/ArtworkCard/ArtworkCard';
import styles from './HomePage.module.css';

function HomePage() {
  return (
    <>
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Welcome to JT's Art!</h1>
        <p className={styles.heroSubtitle}>
          Original artwork made with love, color, and a whole lot of imagination.
        </p>
      </section>
      <section className={styles.gallery}>
        <h2 className={styles.galleryTitle}>The Gallery</h2>
        <div className={styles.grid}>
          {artworks.map((artwork) => (
            <ArtworkCard key={artwork.id} artwork={artwork} />
          ))}
        </div>
      </section>
    </>
  );
}

export default HomePage;
